import React from 'react';
import Overview from './Overview';
import BudgetItems from './BudgetItems';
import ScopeDetail from './ScopeDetail';
import ProjectSettings from './ProjectSettings';

export default function Construction({ activeTab, selectedScope, navigateTo }) {
  return (
    <div className="rounded-lg bg-white px-5 py-6 shadow-sm sm:px-6">
      {/* Subnav */}
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8" aria-label="Construction Navigation">
          <button
            onClick={navigateTo.construction.overview}
            className={`${
              activeTab === 'overview'
                ? 'border-indigo-500 text-indigo-600'
                : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
            } whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium`}
          >
            Overview
          </button>
          <button
            onClick={navigateTo.construction.budget}
            className={`${
              activeTab === 'budget'
                ? 'border-indigo-500 text-indigo-600'
                : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
            } whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium`}
          >
            Budget Items
          </button>
          <button
            onClick={() => navigateTo.construction.settings && navigateTo.construction.settings()}
            className={`${
              activeTab === 'settings'
                ? 'border-indigo-500 text-indigo-600'
                : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
            } whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium`}
          >
            Project Settings
          </button>
        </nav>
      </div>

      {/* Content area */}
      <div className="mt-6">
        {activeTab === 'overview' && <Overview />}
        {activeTab === 'budget' && !selectedScope && (
          <BudgetItems onSelectScope={(scopeName) => navigateTo.construction.scopeDetail(scopeName)} />
        )}
        {activeTab === 'budget' && selectedScope && (
          <ScopeDetail 
            scope={null} // Will be fetched in the component
            scopeName={selectedScope}
            onBack={() => navigateTo.construction.budget()}
          />
        )}
        {activeTab === 'settings' && <ProjectSettings />}
      </div>
    </div>
  );
}